import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16">
      <div className="bg-gradient-to-b from-white/0 to-pink-50/60 border-t border-white/60">
        <div className="mx-auto max-w-7xl px-5 md:px-8 py-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="text-sm text-slate-600">
              Zebra MicroWealth offers secure and responsible lending solutions in South Africa.
            </div>
            <div className="flex items-center gap-4 text-sm">
              <Link className="text-slate-600 hover:text-slate-900" to="/about">About</Link>
              <Link className="text-slate-600 hover:text-slate-900" to="/how-it-works">How it works</Link>
              <Link className="text-slate-600 hover:text-slate-900" to="/faq">FAQ</Link>
              <Link className="text-slate-600 hover:text-slate-900" to="/contact">Contact</Link>
              <span className="text-slate-300">|</span>
              <a className="text-slate-600 hover:text-slate-900" href="/privacy-policy">Privacy Policy</a>
              <a className="text-slate-600 hover:text-slate-900" href="/terms-of-service">Terms of Service</a>
            </div>
          </div>

          <div className="mt-6 text-xs text-slate-500">
            Copyright © {new Date().getFullYear()} Zebra MicroWealth. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
